import constants from '@Common/Core/Constant';
import { ReportType, TimeInterval } from '@Common/Enums/Enum';

export interface IContextMenuItem {
    id: string;
    name?: string;
    icon?: string;
    iconSize?: string;
    enabled?: boolean;
    isSeparator?: boolean;
    parentId?: string;
    isTrellis?: boolean;
    data?: any;
}

type Cast<K, U> = { [P in keyof K]: U };

function cast<K, U>(obj: K): Cast<K, U> {
    return <any>obj;
}

const localContextMenuItems = {
    locale: { id: 'locale', name: strings.contextMenuItems.locale, icon: 'Commands/generateLanguages.png' },
    theme: { id: 'theme', name: strings.contextMenuItems.theme, icon: 'Commands/Edit-Theme.png' },
    about: { id: 'about', name: strings.contextMenuItems.about, icon: 'ContextMenuIcons/about.png' },
    help: { id: 'help', name: strings.contextMenuItems.help, icon: 'Commands/help.png' },
    reset: { id: 'reset', name: strings.contextMenuItems.reset, icon: 'ContextMenuIcons/reset.png' },
    pivot: {
        id: 'pivot',
        name: strings.contextMenuItems.pivot,
        icon: 'ContextMenuIcons/pivot.png',
        canBeChecked: true
    },
    createMarker: {
        id: 'createMarker',
        name: strings.contextMenuItems.createMarker,
        icon: 'ContextMenuIcons/marker.png'
    },
    zoom: { id: 'zoom', name: strings.contextMenuItems.zoom },
    animation: { id: 'animation', name: strings.contextMenuItems.animation, icon: 'ContextMenuIcons/animation.png' },
    print: { id: 'print', name: strings.contextMenuItems.print, icon: 'ContextMenuIcons/print.png' },
    view: { id: 'view', name: strings.contextMenuItems.view },
    viewer: { id: 'viewer', name: strings.contextMenuItems.viewer },
    trellis: { id: 'trellis', name: strings.contextMenuItems.trellis },

    removePoint: { id: 'removePoint', name: strings.contextMenuItems.removePoint },
    removeSeries: { id: 'removeSeries', name: strings.contextMenuItems.removeSeries },
    showLabels: { id: 'showLabels', name: strings.contextMenuItems.showLabels },
    showMarkers: { id: 'showMarkers', name: strings.contextMenuItems.showMarkers },

    switchtogrid: {
        id: 'switchtogrid',
        name: strings.contextMenuItems.metricGrid,
        icon: 'ContextMenuIcons/metric-grid.png'
    },
    switchtochart: { id: 'switchtochart', name: strings.contextMenuItems.chart, icon: 'ContextMenuIcons/chart.png' },
    switchToRecordGrid: {
        id: 'toRecord',
        name: strings.contextMenuItems.recordGrid,
        icon: 'ContextMenuIcons/record-grid.png'
    },
    switchToScatterChart: {
        id: 'toScatter',
        name: strings.contextMenuItems.scatter,
        icon: 'ContextMenuIcons/scatter.png'
    },

    back: { id: 'back', name: strings.contextMenuItems.back, icon: 'ContextMenuIcons/back.png' },
    refresh: { id: 'refresh', name: strings.contextMenuItems.refresh, icon: 'ContextMenuIcons/refresh.png' },
    viewRefresh: { id: 'viewRefresh', name: strings.contextMenuItems.refresh, icon: 'ContextMenuIcons/refresh.png' },
    zoomin: { id: 'zoomin', name: strings.contextMenuItems.zoomIn, icon: 'ContextMenuIcons/zoom-in.png' },
    zoomout: { id: 'zoomout', name: strings.contextMenuItems.zoomOut, icon: 'ContextMenuIcons/zoom-out.png' },
    logout: { id: 'logout', name: strings.contextMenuItems.logout, icon: 'ContextMenuIcons/logout.png' },
    changePassword: {
        id: 'changePassword',
        name: strings.contextMenuItems.changePassword,
        icon: 'Commands/ChangePassword.png'
    },
    bookmarks: { id: 'bookmarks', name: strings.contextMenuItems.bookmarks, icon: 'Commands/star.png' },
    saveBookmark: {
        id: 'saveBookmarks',
        name: strings.contextMenuItems.saveBookmark,
        icon: 'ContextMenuIcons/save.png'
    },
    clearCache: { id: 'clearCache', name: strings.contextMenuItems.clearCache },
    settings: { id: 'settings', name: strings.contextMenuItems.settings },
    updateModel: { id: 'updateDefinitions', name: strings.contextMenuItems.update },

    grouping: { id: 'grouping', name: strings.contextMenuItems.grouping },
    groupingMode: { id: 'groupingMode', name: strings.contextMenuItems.groupingMode, parentId: 'grouping' },
    groupingEnabled: { id: 'groupingEnabled', name: strings.contextMenuItems.groupingEnabled, parentId: 'grouping' },
    groupingOthers: { id: 'groupingOthers', name: strings.contextMenuItems.groupingOthers, parentId: 'grouping' },

    sort: {
        id: 'sort',
        name: strings.contextMenuItems.sortBy,
        icon: 'ContextMenuIcons/sort.png',
        mobileicon: 'ContextMenuIcons/sort-mobile.png'
    },
    sortByValue: { id: 'sortByValue', name: strings.contextMenuItems.value, parentId: 'sort' },
    sortByValueAsc: { id: 'sortByValueAsc', name: strings.contextMenuItems.ascending, parentId: 'sortByValue' },
    sortByValueDesc: { id: 'sortByValueDesc', name: strings.contextMenuItems.descending, parentId: 'sortByValue' },
    sortByName: { id: 'sortByName', name: strings.contextMenuItems.name, parentId: 'sort' },
    sortByNameAsc: { id: 'sortByNameAsc', name: strings.contextMenuItems.ascending, parentId: 'sortByName' },
    sortByNameDesc: { id: 'sortByNameDesc', name: strings.contextMenuItems.descending, parentId: 'sortByName' },
    sortByID: { id: 'sortByID', name: strings.contextMenuItems.id, parentId: 'sort' },
    sortByIDAsc: { id: 'sortByIDAsc', name: strings.contextMenuItems.ascending, parentId: 'sortByID' },
    sortByIDDesc: { id: 'sortByIDDesc', name: strings.contextMenuItems.descending, parentId: 'sortByID' },
    sortByTime: { id: 'sortByTime', name: strings.contextMenuItems.time, parentId: 'sort' },
    sortByTimeAsc: { id: 'sortByTimeAsc', name: strings.contextMenuItems.ascending, parentId: 'sortByTime' },
    sortByTimeDesc: { id: 'sortByTimeDesc', name: strings.contextMenuItems.descending, parentId: 'sortByTime' },

    zoomOnTime: {
        id: 'zoomOnTime',
        name: strings.contextMenuItems.time,
        icon: 'ContextMenuIcons/time-zoom.png',
        mobileicon: 'ContextMenuIcons/time-zoom-mobile.png'
    },
    zoom1D: {
        id: 'zoom1D',
        name: strings.contextMenuItems['1d'],
        data: { intervalType: TimeInterval.day1, intervalCount: 1 },
        parentId: 'zoomOnTime'
    },
    zoom10D: {
        id: 'zoom10D',
        name: strings.contextMenuItems['10d'],
        data: { intervalType: TimeInterval.day1, intervalCount: 10 },
        parentId: 'zoomOnTime'
    },
    zoom1M: {
        id: 'zoom1M',
        name: strings.contextMenuItems['1m'],
        data: { intervalType: TimeInterval.month1, intervalCount: 1 },
        parentId: 'zoomOnTime'
    },
    zoom3M: {
        id: 'zoom3M',
        name: strings.contextMenuItems['3m'],
        data: { intervalType: TimeInterval.month1, intervalCount: 3 },
        parentId: 'zoomOnTime'
    },
    zoom6M: {
        id: 'zoom6M',
        name: strings.contextMenuItems['6m'],
        data: { intervalType: TimeInterval.month1, intervalCount: 6 },
        parentId: 'zoomOnTime'
    },
    zoom1Y: {
        id: 'zoom1Y',
        name: strings.contextMenuItems['1y'],
        data: { intervalType: TimeInterval.year1, intervalCount: 1 },
        parentId: 'zoomOnTime'
    },
    zoom3Y: {
        id: 'zoom3Y',
        name: strings.contextMenuItems['3y'],
        data: { intervalType: TimeInterval.year1, intervalCount: 3 },
        parentId: 'zoomOnTime'
    },
    zoom5Y: {
        id: 'zoom5Y',
        name: strings.contextMenuItems['5y'],
        data: { intervalType: TimeInterval.year1, intervalCount: 5 },
        parentId: 'zoomOnTime'
    },
    zoom10Y: {
        id: 'zoom10Y',
        name: strings.contextMenuItems['10y'],
        data: { intervalType: TimeInterval.year1, intervalCount: 10 },
        parentId: 'zoomOnTime'
    },

    scale: { id: 'scale', name: strings.contextMenuItems.scale },
    scale10: { id: 'scale10', name: strings.contextMenuItems.scale10, data: { scale: 10 }, parentId: 'scale' },
    scale25: { id: 'scale25', name: strings.contextMenuItems.scale25, data: { scale: 25 }, parentId: 'scale' },
    scale50: { id: 'scale50', name: strings.contextMenuItems.scale50, data: { scale: 50 }, parentId: 'scale' },
    scale75: { id: 'scale75', name: strings.contextMenuItems.scale75, data: { scale: 75 }, parentId: 'scale' },
    scale100: { id: 'scale100', name: strings.contextMenuItems.scale100, data: { scale: 100 }, parentId: 'scale' },
    scale150: { id: 'scale150', name: strings.contextMenuItems.scale150, data: { scale: 150 }, parentId: 'scale' },
    scale200: { id: 'scale200', name: strings.contextMenuItems.scale200, data: { scale: 200 }, parentId: 'scale' },
    scale500: { id: 'scale500', name: strings.contextMenuItems.scale500, data: { scale: 500 }, parentId: 'scale' },
    fitToComponent: { id: 'fitToComponent', name: strings.contextMenuItems.fitToComponent, parentId: 'scale' },
    customScale: { id: 'customScale', name: strings.contextMenuItems.customScale, parentId: 'scale' },

    information: { id: 'information', name: strings.contextMenuItems.info, icon: 'ContextMenuIcons/information.png' },
    viewInformation: {
        id: 'viewInformation',
        name: strings.contextMenuItems.viewInfo,
        icon: 'ContextMenuIcons/information.png'
    },
    openInDesigner: {
        id: 'openInDesigner',
        name: strings.contextMenuItems.openInDesigner,
        icon: 'ContextMenuIcons/openInDesigner.png'
    },
    viewHolderInformation: {
        id: 'viewHolderInformation',
        name: strings.contextMenuItems.viewHolderInfo,
        icon: 'ContextMenuIcons/information.png'
    },
    viewHolder: { id: 'viewHolderInformation', name: strings.contextMenuItems.viewHolder },
    parentView: { id: 'parentView', name: strings.contextMenuItems.parentView },
    logging: { id: 'logging', name: strings.contextMenuItems.logging, canBeChecked: true },
    export: { id: 'export', name: strings.contextMenuItems.export },
    exportToExcel: { id: 'exportToExcel', name: strings.contextMenuItems.exportToExcel, parentId: 'export' },
    exportToImage: { id: 'exportToImage', name: strings.contextMenuItems.exportToImage, parentId: 'export' },

    statistics: {
        id: 'statistics',
        name: strings.contextMenuItems.stat,
        icon: 'ContextMenuIcons/statistics.png',
        mobileicon: 'ContextMenuIcons/statistics-mobile.png'
    },
    showMeanLine: { id: 'showMeanLine', name: strings.contextMenuItems.meanLine, parentId: 'statistics' },
    showMeanLineByCategory: {
        id: 'showMeanLineByCategory',
        name: strings.contextMenuItems.byCategory,
        canBeChecked: true,
        parentId: 'showMeanLine'
    },
    showMeanLineForAllPoints: {
        id: 'showMeanLineForAllPoints',
        name: strings.contextMenuItems.allPoints,
        canBeChecked: true,
        parentId: 'showMeanLine'
    },
    showMeanLineNone: {
        id: 'showMeanLineNone',
        name: strings.contextMenuItems.none,
        canBeChecked: true,
        parentId: 'showMeanLine'
    },
    showMedianLine: { id: 'showMedianLine', name: strings.contextMenuItems.medianLine, parentId: 'statistics' },
    showMedianLineByCategory: {
        id: 'showMedianLineByCategory',
        name: strings.contextMenuItems.byCategory,
        canBeChecked: true,
        parentId: 'showMedianLine'
    },
    showMedianLineForAllPoints: {
        id: 'showMedianLineForAllPoints',
        name: strings.contextMenuItems.allPoints,
        canBeChecked: true,
        parentId: 'showMedianLine'
    },
    showMedianLineNone: {
        id: 'showMedianLineNone',
        name: strings.contextMenuItems.none,
        canBeChecked: true,
        parentId: 'showMedianLine'
    },
    showStandardDeviations: {
        id: 'showStandardDeviations',
        name: strings.contextMenuItems.stdDeviations,
        parentId: 'statistics'
    },
    showStandardDeviationsByCategory: {
        id: 'showStandardDeviationsByCategory',
        name: strings.contextMenuItems.byCategory,
        canBeChecked: true,
        parentId: 'showStandardDeviations'
    },
    showStandardDeviationsForAllPoints: {
        id: 'showStandardDeviationsForAllPoints',
        name: strings.contextMenuItems.allPoints,
        canBeChecked: true,
        parentId: 'showStandardDeviations'
    },
    showStandardDeviationsNone: {
        id: 'showStandardDeviationsNone',
        name: strings.contextMenuItems.none,
        canBeChecked: true,
        parentId: 'showStandardDeviations'
    },
    showPercentile: { id: 'showPercentile', name: strings.contextMenuItems.percentile, parentId: 'statistics' },
    showPercentileByCategory: {
        id: 'showPercentileByCategory',
        name: strings.contextMenuItems.byCategory,
        canBeChecked: true,
        parentId: 'showPercentile'
    },
    showPercentileForAllPoints: {
        id: 'showPercentileForAllPoints',
        name: strings.contextMenuItems.allPoints,
        canBeChecked: true,
        parentId: 'showPercentile'
    },
    showPercentileNone: {
        id: 'showPercentileNone',
        name: strings.contextMenuItems.none,
        canBeChecked: true,
        parentId: 'showPercentile'
    },
    showFStatistics: { id: 'showFStatistics', name: strings.contextMenuItems.fStatistics, parentId: 'statistics' },
    showCounts: { id: 'showCounts', name: strings.contextMenuItems.counts, parentId: 'statistics' },
    showColoredCells: { id: 'showColoredCells', name: strings.contextMenuItems.coloredCells, parentId: 'statistics' },

    processActions: { id: 'processActions', name: strings.contextMenuItems.actionWizard },
    processConfiguration: {
        id: 'processConfiguration',
        name: strings.contextMenuItems.processConfig,
        icon: 'ContextMenuIcons/process-config.png'
    },
    processFilterOptions: {
        id: 'processFilterOptions',
        name: strings.contextMenuItems.processFilter,
        icon: 'ContextMenuIcons/process-filter.png'
    },
    processFilterDefinition: { id: 'processFilterDefinition', name: strings.contextMenuItems.processFilterDefinition },
    processSwimlaneGrouping: { id: 'processSwimlaneGrouping', name: strings.contextMenuItems.processSwimlaneGrouping },
    processSwimlaneGroupingDialog: {
        id: 'processSwimlaneGroupingDialog',
        name: strings.contextMenuItems.processSwimlaneGroupingDialog,
        parentId: 'processSwimlaneGrouping'
    },
    processSwimlaneGroupingMode: {
        id: 'processSwimlaneGroupingMode',
        name: strings.contextMenuItems.processSwimlaneGroupingMode,
        parentId: 'processSwimlaneGrouping'
    },

    mapSettings: {
        id: 'mapSettnigs',
        name: strings.contextMenuItems.mapSettings,
        icon: 'ContextMenuIcons/refresh.png'
    },

    chartTypes: { id: 'chartTypes', name: strings.contextMenuItems.chartType },

    copy: { id: 'copy', name: strings.contextMenuItems.copy, icon: 'ContextMenuIcons/copy.png' },
    copyCell: { id: 'copyCell', name: strings.contextMenuItems.copyCell, parentId: 'copy' },
    copyRow: { id: 'copyRow', name: strings.contextMenuItems.copyRow, parentId: 'copy' },
    paste: { id: 'paste', name: strings.contextMenuItems.paste, icon: 'ContextMenuIcons/paste.png' },
    editTitle: { id: 'editTitle', name: strings.contextMenuItems.editTitle, icon: 'ContextMenuIcons/title-16.png' },
    edit: { id: 'edit', name: strings.contextMenuItems.edit, icon: 'ContextMenuIcons/edit.png' },

    deleteComponents: {
        id: 'deleteComponents',
        name: strings.contextMenuItems.deleteComponents,
        icon: 'ContextMenuIcons/delete.png'
    },

    newProcessStep: {
        id: 'newProcessStep',
        name: strings.contextMenuItems.newProcessStep,
        icon: 'ContextMenuIcons/newDocument.png'
    },
    generateProcessSteps: { id: 'generateProcessSteps', name: strings.contextMenuItems.generateProcessSteps },
    deleteProcessTransition: {
        id: 'deleteProcessTransition',
        name: strings.contextMenuItems.remove,
        icon: 'ContextMenuIcons/delete.png'
    },

    add: { id: 'add', name: strings.contextMenuItems.add, icon: 'ContextMenuIcons/addView.png' },
    addRole: { id: 'addRole', name: strings.contextMenuItems.addRole, icon: 'ContextMenuIcons/addView.png' },
    addAdminRole: {
        id: 'addAdminRole',
        name: strings.contextMenuItems.addAdminRole,
        icon: 'ContextMenuIcons/addView.png'
    },
    addFolder: { id: 'addFolder', name: strings.contextMenuItems.addFolder, icon: 'ContextMenuIcons/newDocument.png' },
    remove: { id: 'remove', name: strings.contextMenuItems.remove, icon: 'ContextMenuIcons/delete.png' },
    removeToTheLeft: { id: 'removeToTheLeft', name: strings.contextMenuItems.removeToTheLeft },
    removeToTheRight: { id: 'removeToTheRight', name: strings.contextMenuItems.removeToTheRight },
    rename: { id: 'rename', name: strings.contextMenuItems.rename, icon: 'ContextMenuIcons/rename.png' },
    open: { id: 'open', name: strings.contextMenuItems.open, icon: 'ContextMenuIcons/open.png' },
    showUsages: {
        id: constants.commands.showUsages,
        name: strings.contextMenuItems.showUsages,
        icon: 'description.png'
    },

    separator: { id: 'separator', name: null, isSeparator: true },

    dataWizard: {
        id: constants.commands.dataWizard,
        name: strings.contextMenuItems.dataWizard,
        icon: 'ContextMenuIcons/data.png'
    },
    timeWizard: {
        id: constants.commands.timeWizard,
        name: strings.contextMenuItems.timeWizard,
        icon: 'ContextMenuIcons/time.png'
    },
    displayWizard: {
        id: constants.commands.displayWizard,
        name: strings.contextMenuItems.displayWizard,
        icon: 'ContextMenuIcons/displayOptions.png'
    },
    actionWizard: {
        id: constants.commands.actionWizard,
        name: strings.contextMenuItems.actionWizard,
        icon: 'ContextMenuIcons/actions.png'
    },

    getComponentUrl: {
        id: 'getComponentUrl',
        name: strings.contextMenuItems.getComponentUrl,
        icon: 'ContextMenuIcons/link.png'
    },
    getUrl: { id: 'getUrl', name: strings.contextMenuItems.getComponentUrl, icon: 'ContextMenuIcons/link.png' },

    addMappingSource: {
        id: 'addMappingSource',
        name: strings.contextMenuItems.addMappingSource,
        icon: 'Commands/add.png'
    },
    editMappingSource: {
        id: 'editMappingSource',
        name: strings.contextMenuItems.editMappingSource,
        icon: 'Commands/edit.png'
    },
    removeMappingSource: {
        id: 'removeMappingSource',
        name: strings.contextMenuItems.removeMappingSource,
        icon: 'ContextMenuIcons/delete.png'
    },
    openMappingSource: {
        id: 'openMappingSource',
        name: strings.contextMenuItems.openMappingSource,
        icon: 'Commands/open.png'
    },
    replaceSource: { id: 'replaceMappingSource', name: strings.contextMenuItems.replaceMappingSource, icon: '' },
    replaceDataSource: {
        id: 'replaceMappingDataSource',
        name: strings.contextMenuItems.replaceMappingDataSource,
        icon: ''
    },

    openViewFromViewHolder: {
        id: 'openViewFromViewHolder',
        name: strings.contextMenuItems.openView,
        icon: 'ContextMenuIcons/openView.png'
    },

    moveUp: { id: 'moveUp', name: strings.contextMenuItems.moveUp, icon: 'ContextMenuIcons/moveUp.png' },
    moveDown: { id: 'moveDown', name: strings.contextMenuItems.moveDown, icon: 'ContextMenuIcons/moveDown.png' },

    addReport: {
        id: 'addReport',
        name: strings.contextMenuItems.addReport,
        icon: 'ContextMenuIcons/addView.png',
        reportType: ReportType.report
    },
    addAdvancedReport: {
        id: 'addAdvancedReport',
        name: strings.contextMenuItems.addAdvancedReport,
        icon: 'ContextMenuIcons/addView.png',
        reportType: ReportType.advancedReport
    },
    addCacheReport: {
        id: 'addCacheReport',
        name: strings.contextMenuItems.addCacheReport,
        icon: 'ContextMenuIcons/addView.png',
        reportType: ReportType.cacheReport
    },
    addAdvancedCacheReport: {
        id: 'addAdvancedCacheReport',
        name: strings.contextMenuItems.addAdvancedCacheReport,
        icon: 'ContextMenuIcons/addView.png',
        reportType: ReportType.advancedCacheReport
    },
    addGridExtractor: {
        id: 'addGridExtractor',
        name: strings.contextMenuItems.addGridExtractor,
        icon: 'ContextMenuIcons/addView.png',
        reportType: ReportType.gridExtractor
    },
    addAdvancedGridExtractor: {
        id: 'addAdvancedGridExtractor',
        name: strings.contextMenuItems.addAdvancedGridExtractor,
        icon: 'ContextMenuIcons/addView.png',
        reportType: ReportType.advancedGridExtractor
    },

    closeAll: { name: strings.contextMenuItems.closeAll, id: 'closeAll' },
    closeAllExceptCurrent: { name: strings.contextMenuItems.closeAllExceptCurrent, id: 'closeAllExceptCurrent' },
    closeCurrent: { name: strings.contextMenuItems.closeCurrent, id: 'closeCurrent' },
    toggleTestSession: {
        id: 'toggleTestSession',
        name: strings.commands.toggleTestSession,
        icon: 'Commands/Test-case-record-start-2.png'
    },
    selection: { id: 'selection', name: strings.contextMenuItems.selection.groupName },
    selectFirstN: { id: 'selectFirstN', name: strings.contextMenuItems.selection.selectFirstN, parentId: 'selection' },
    clearSelect: { id: 'clearSelect', name: strings.contextMenuItems.selection.clearSelect, parentId: 'selection' }
};

export const contextMenuItems =
    //localContextMenuItems as any;
    cast<typeof localContextMenuItems, IContextMenuItem>(localContextMenuItems);
